import { render, staticRenderFns } from "./Remuneraciones.vue?vue&type=template&id=45fcda50&scoped=true&"
import script from "./Remuneraciones.vue?vue&type=script&lang=js&"
export * from "./Remuneraciones.vue?vue&type=script&lang=js&"
import style0 from "./Remuneraciones.vue?vue&type=style&index=0&id=45fcda50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fcda50",
  null
  
)

export default component.exports